import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=ef4a4ef4&scoped=true&"
import script from "./TasksList.vue?vue&type=script&lang=js&"
export * from "./TasksList.vue?vue&type=script&lang=js&"
import style0 from "./TasksList.vue?vue&type=style&index=0&id=ef4a4ef4&lang=scss&scoped=true&"
import style1 from "./TasksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a4ef4",
  null
  
)

export default component.exports